import React from 'react';
import { BotIcon, TrendingUpIcon, MessageSquareIcon } from 'lucide-react';
const aiCards = [{
  icon: BotIcon,
  title: 'AI Assistants & Smart Automation',
  body: 'Deploy intelligent agents that handle routine tasks, provide instant answers, and learn from your business processes.'
}, {
  icon: TrendingUpIcon,
  title: 'AI-Powered SEO & Analytics',
  body: 'Optimize your digital presence with AI-driven insights, content recommendations, and performance analysis.'
}, {
  icon: MessageSquareIcon,
  title: '24/7 AI Live Chat',
  body: 'Engage visitors around the clock with conversational AI that answers questions and qualifies leads automatically.'
}];
export function AIHighlight() {
  return <section className="py-20 bg-primary texture-dark texture-grid relative overflow-hidden" data-id="element-284">
      <div className="absolute inset-0 bg-gradient-to-br from-secondary/20 via-transparent to-teal/5" data-id="element-285"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-286">
        <div className="text-center mb-16 scroll-fade-in-up" data-id="element-287">
          <span className="inline-block text-xs font-bold tracking-widest uppercase text-teal mb-3" data-id="element-288">
            AI & Automation
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-289">
            AI-Powered Capabilities
          </h2>
          <p className="text-xl text-blue-200 max-w-3xl mx-auto" data-id="element-290">
            Leverage artificial intelligence to automate workflows and scale
            your business
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 scroll-fade-in-up" data-id="element-291">
          {aiCards.map(({
          icon: Icon,
          title,
          body
        }) => <div key={title} className="card-dark-premium border border-divider/50 p-8 rounded-xl backdrop-blur-sm" data-id="element-292">
              <div className="w-14 h-14 rounded-xl flex items-center justify-center mb-6 bg-gradient-to-br from-teal/15 to-teal/5 border border-teal/20" data-id="element-293">
                <Icon className="w-7 h-7 text-teal" data-id="element-294" />
              </div>
              <h3 className="text-2xl font-bold text-white mb-3" data-id="element-295">{title}</h3>
              <p className="text-blue-200 leading-relaxed" data-id="element-296">{body}</p>
            </div>)}
        </div>
      </div>
    </section>;
}